import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { esConsultaPost, esModoMarcador } from './huella-rbac';
import { registrarLlamadaMarcador } from './rbac-marcador.service';

/**
 * EN MODO MARCADOR LA PANTALLA SOLO LEE.
 *
 * Dentro del iframe de «Agregar permisos» (ver rbac-marcador.service.ts) se ve la pantalla con datos reales, pero
 * nada puede cambiarse: además de frenar los clics, toda petición que no sea GET se rechaza aquí, sin salir a la red.
 * Fuera de ese modo no hace nada: pasa la petición tal cual.
 *
 * Se registra primero en app.module.ts, así el rechazo ocurre antes de que el resto de interceptores toquen la
 * petición. Además anota el método y la URL de cada petición (las GET que pasan y las que se rechazan) para que la pestaña
 * ofrezca «las llamadas que la pantalla hizo al cargarse» (ver registrarLlamadaMarcador). El error es un 405 (no un 401), para que nada lo confunda con una sesión vencida.
 */
@Injectable({ providedIn: 'root' })
export class RbacMarcadorInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const marcador = esModoMarcador(window);
    if (marcador) registrarLlamadaMarcador(req.method, req.url);
    if (marcador && req.method !== 'GET' && !esConsultaPost(req.method, req.url)) {
      const msg = 'Modo marcador: la pantalla solo se puede mirar, no se guarda ni se cambia nada.';
      return throwError(() => new HttpErrorResponse({
        status: 405,
        statusText: 'Modo marcador',
        url: req.url,
        error: { ok: false, msg },
      }));
    }
    return next.handle(req);
  }
}
